import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { isString } from '@maplecroft-typescript/utils';
import { WINDOW } from '@maplecroft-ui/ng-utils';
import { Observable } from 'rxjs';
import { IP_LOGIN_TOKEN_STORAGE_KEY } from './constants';

const IP_LOGIN_AUTHORIZATION_URLS_REGEX = [/cms-api/, /cms-assets/];
const IP_LOGIN_CUSTOM_HEADER_URLS_REGEX = [/maps.*\/v1\/authenticate/];

@Injectable()
export class IpLoginTokenInterceptor implements HttpInterceptor {
  private readonly sessionStorage = inject(WINDOW).sessionStorage;

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.sessionStorage.getItem(IP_LOGIN_TOKEN_STORAGE_KEY);

    if (isString(token)) {
      if (IP_LOGIN_AUTHORIZATION_URLS_REGEX.some((regex) => regex.test(request.url))) {
        request = request.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
      } else if (IP_LOGIN_CUSTOM_HEADER_URLS_REGEX.some((regex) => regex.test(request.url))) {
        request = request.clone({
          setHeaders: { 'X-IP-Login-Token': `Bearer ${token}` },
        });
      }
    }

    return next.handle(request);
  }
}
